import { useQuery } from '@tanstack/vue-query';
import apiInterceptor from '@/shared/apiInterceptor';
import { environment } from '@/shared/env';

/**
 * Returns TanStack Query options for the segments list endpoint.
 */
export const segmentsQueryOptions = () => ({
  queryKey: ['segments'],
  queryFn: async () => {
    const r = await apiInterceptor.get(environment('VUE_APP_API_URL') + 'crm/v1/segments/');
    return r?.segments || [];
  },
  staleTime: 5 * 60 * 1000, // 5 minutes
});

/**
 * Composable wrapper for use inside <script setup> components.
 * Returns { data: Ref<segment[]>, isPending, isError, ... }
 */
export function useSegments() {
  return useQuery(segmentsQueryOptions());
}
